<template>
  <div class="Landing">

    <h1 class="header">
      <emoji class="emoji">
        🚂
      </emoji>
      Resebingo
    </h1>

    <!--iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fresebingo.se%2F&width=300&layout=standard&action=like&size=small&show_faces=true&share=true&height=80" width="300" height="80" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe-->

    <!--iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fresebingo%2F&tabs&width=500&height=180&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1196347747065674" width="500" height="180" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe-->

    <br />

    <share></share>

    <brick :size="3" class="brick"></brick>

    <span class="randomize" @click="randomize()">
      <emoji class="emoji">
        🔄
      </emoji>
    </span>

    <br />

    <h3>Gilla Resebingo på Facebook!</h3>
    <div class="fb-page" data-href="https://www.facebook.com/resebingo/" data-width="500" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/resebingo/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/resebingo/">Resebingo</a></blockquote></div>

    <!--iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fresebingo%2F&tabs&width=500&height=180&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1196347747065674" width="500" height="180" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe-->

  </div>
</template>

<script>

import { store } from '@/store';

import Emoji from '@/components/Emoji'
import Brick from '@/components/Brick'
import Bingo from '@/components/Bingo'
import Share from '@/components/Share'

export default {
  name: 'Landing',
  components: {
    Emoji,
    Brick,
    Bingo,
    Share
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  computed: {
    bingo: function () {
      return store.state.bingo;
    },
    shareStr: function () {
      return store.state.shareStr;
    }
  },
  watch: {
    shareStr: function (val) {
      //this.$route.query["b"] = "hej";
      //this.$router.replace({query: {b: val}})
    }
  },
  methods: {
    randomize: function () {
      let params = {
        size: 3
      }
      store.commit('generateBrick',params);
    }
  },
  mounted: function () {
    if(this.$route.query.b){
      let params = {
        b: this.$route.query.b
      }
      store.commit('generateBrickFromQuery',params);
      this.$router.replace({query: {b: undefined}})
    }
    else{
      let params = {
        size: 3,
      }
      store.commit('init',params);
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.Landing{
  /*text-align: center;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  /*background: url('/static/graphics/railway-bright.jpg');
  background-size: cover;
  background-position: center;*/
}

.header{
  font-size: 15vw;
}

@media screen and (min-width: 600px) {
  .header{
    font-size: 6em;
  }
}

.brick{
  margin: 20px 0 20px 0;
}

.randomize{
  font-size: 30pt;
  text-align: center;
  cursor: pointer;
  filter: saturate(0);
  transition: all 0.1s;
}

.randomize:hover{
  filter: saturate(1);
}



</style>



// WEBPACK FOOTER //
// src/components/Landing.vue